import React, { useContext } from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';

import sharedVars from '@wix/da-ds/src/styles/variables.scss';

export interface Props {
  className?: string;
}

const SiteHeaderPlacement: React.FC<Props> = ({ className }) => {
  const { isLoggedIn } = useContext(SessionContext);

  // User
  if (isLoggedIn) {
    return (
      <BannerAdUnit
        width="100px"
        height={sharedVars['site-header-height']}
        realEstateId="7762cc44-45ad-436a-b170-f4dc4426f5ae"
        className={className}
      />
    );
  }

  // Anon
  return (
    <BannerAdUnit
      width="100px"
      height={sharedVars['site-header-height']}
      realEstateId="862f0865-3b30-4936-ae6b-a24fb0d1f330"
      className={className}
    />
  );
};
SiteHeaderPlacement.displayName = 'SiteHeaderPlacement';

export default SiteHeaderPlacement;
